
    import __i18nConfig from '@next-translate-root/i18n.json'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import useLocale from 'next-translate/useTranslation';
import React from 'react';
import Footer from '@/components/layout/Footer';
import LandingPageNavigation from '@/components/layout/LandingPageNavigation';
import Seo from '@/components/Seo';
const SubProcessors = () => {
    const { t } = useLocale('common');
    return (<main>
      <Seo templateTitle='Sub-Processors' image={`https://easy-peasy.ai/api/og-template?title=${t('Sub-Processors')}`}/>
      <div className='relative dark:bg-slate-900 bg-white'>
        <div className='mx-auto'>
          <div className='relative z-10 dark:bg-slate-900 bg-white sm:pb-8 lg:w-full'>
            <LandingPageNavigation />
          </div>
        </div>
      </div>
      <section className='bg-white dark:bg-slate-900 py-16 px-4 sm:px-6 lg:px-8'>
        <div className='prose prose-lg prose-indigo mx-auto mt-6 text-gray-500 dark:text-slate-400'>
          <div className='max-w-3xl mx-auto xl:max-w-4xl'>
            <h1 className='text-3xl font-bold dark:text-slate-200 text-gray-900 sm:text-4xl xl:text-3xl'>
              Sub-Processors
            </h1>{' '}
            <p className='text-lg mt-2'>
              Easy-Peasy.AI uses certain sub-processors (including third
              parties, as listed below) and content delivery networks to assist
              it in providing the Easy-Peasy.AI Services as described in the
              Master Subscription and Professional Services Agreement (“MSA”).
              Defined terms used herein shall have the same meaning as defined
              in the MSA.
            </p>{' '}
            <hr className='border border-gray-200 w-full mt-8'/>{' '}
            <div className='nuxt-content prose mx-auto mt-8 dark:text-slate-400'>
              <h2 id='what-is-a-sub-processor' className='dark:text-slate-200'>
                <a href='#what-is-a-sub-processor' aria-hidden='true'>
                  <span className='icon icon-link'></span>
                </a>
                What is a Sub-processor?
              </h2>
              <p>
                A sub-processor is a third-party data processor engaged by
                Easy-Peasy.AI, including entities from within Easy-Peasy.AI, who
                has or potentially will have access to or process Customer
                Content containing personal information. Easy-Peasy.AI engages
                different types of sub-processors to perform various functions
                as explained in the tables below.
              </p>
              <h3 id='due-diligence--contractual-safeguards' className='dark:text-slate-200'>
                <a href='#due-diligence--contractual-safeguards' aria-hidden='true'>
                  <span className='icon icon-link'></span>
                </a>
                Due Diligence &amp; Contractual Safeguards
              </h3>
              <p>
                Easy-Peasy.AI evaluates the security, privacy and
                confidentiality practices of proposed sub-processors that will
                or may have access to or otherwise process Customer Content and
                enters into Data Protection Agreements with each such
                sub-processor.
              </p>
              <p>
                This advisory does not give Customers any additional rights or
                remedies and should not be construed as a binding agreement. The
                information herein is only provided to illustrate
                Easy-Peasy.AI’s engagement process for sub-processors as well as
                to provide the actual list of third party sub-processors and
                content delivery networks used by Easy-Peasy.AI as of the date
                of this advisory (which Easy-Peasy.AI may use in the delivery
                and support of its Services).
              </p>
              <p>
                If you are a Easy-Peasy.AI customer and wish to enter into our
                DPA, please email us at{' '}
                <a href='mailto:support@easy-peasy.ai'>support@easy-peasy.ai</a>
                .
              </p>
              <h3 id='process-to-engage-new-sub-processors' className='dark:text-slate-200'>
                <a href='#process-to-engage-new-sub-processors' aria-hidden='true'>
                  <span className='icon icon-link'></span>
                </a>
                Process to Engage New Sub-processors:
              </h3>
              <p>
                Easy-Peasy.AI provides notice via this advisory of updates to
                the list of sub-processors that are utilized, or which
                Easy-Peasy.AI proposes to utilize to deliver its Services.
                Easy-Peasy.AI undertakes to keep this list updated regularly to
                enable its Customers to stay informed of the scope of
                sub-processing associated with the Services.
              </p>
              <p>
                The following is an up-to-date list (as of the date of this
                advisory) of the names and locations of Easy-Peasy.AI
                sub-processors and content delivery networks.
              </p>
              <h3 className='dark:text-slate-200' id='infrastructure-sub-processors--service-data-storage-and-processing'>
                <a href='#infrastructure-sub-processors--service-data-storage-and-processing' aria-hidden='true'>
                  <span className='icon icon-link'></span>
                </a>
                Infrastructure Sub-processors – Service Data Storage and
                Processing
              </h3>
              <p>
                Easy-Peasy.AI owns or controls access to the infrastructure that
                Easy-Peasy.AI uses to host and process Customer Content, other
                than as set forth herein. Currently, the Easy-Peasy.AI
                production systems used for hosting Customer Content for the
                Services are in facilities in the United States and in the
                infrastructure sub-processors listed below. The following table
                describes the countries and legal entities engaged by
                Easy-Peasy.AI in the storage of Service Data. Easy-Peasy.AI also
                uses additional services provided by these sub-processors to
                process Service Data as needed to provide the Services.
              </p>

              <table>
                <thead>
                  <tr>
                    <th>Entity Name</th>
                    <th>Entity Type</th>
                    <th>Entity Country</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>Vercel</td>
                    <td>
                      Cloud Computing/Data Center Hosting/Content Delivery
                      Network
                    </td>
                    <td>US</td>
                  </tr>
                  <tr>
                    <td>Supabase</td>
                    <td>Cloud Computing/Data Center Hosting</td>
                    <td>US</td>
                  </tr>
                </tbody>
              </table>
              <h2 className='dark:text-slate-200' id='service-specific-sub-processors'>
                <a href='#service-specific-sub-processors' aria-hidden='true'>
                  <span className='icon icon-link'></span>
                </a>
                Service Specific Sub-processors
              </h2>
              <p>
                Easy-Peasy.AI works with certain third parties to provide
                specific functionality within the Services. These providers are
                the Sub-processors set forth below. In order to provide the
                relevant functionality these Sub-processors access Customer
                Content. Their use is limited to the indicated Services.
              </p>
              <h3 className='dark:text-slate-200' id='Easy-Peasy.AI-platform'>
                <a href='#Easy-Peasy.AI-platform' aria-hidden='true'>
                  <span className='icon icon-link'></span>
                </a>
                Easy-Peasy.AI Platform
              </h3>

              <table>
                <thead>
                  <tr>
                    <th>Entity Name</th>
                    <th>Purpose</th>
                    <th>Entity Country</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>Mixpanel</td>
                    <td>Analytics</td>
                    <td>US</td>
                  </tr>
                  <tr>
                    <td>Google Analytics</td>
                    <td>Analytics</td>
                    <td>US</td>
                  </tr>
                  <tr>
                    <td>Crisp, IM SAS</td>
                    <td>Customer support</td>
                    <td>EU</td>
                  </tr>
                  <tr>
                    <td>SendGrid</td>
                    <td>Email marketing</td>
                    <td>US</td>
                  </tr>
                  <tr>
                    <td>OpenAI</td>
                    <td>AI content generation</td>
                    <td>US</td>
                  </tr>
                  <tr>
                    <td>Anthropic</td>
                    <td>AI content generation</td>
                    <td>US</td>
                  </tr>
                  <tr>
                    <td>Stability AI, LTD</td>
                    <td>AI image generation</td>
                    <td>US</td>
                  </tr>
                  <tr>
                    <td>Stripe</td>
                    <td>Payment processing</td>
                    <td>US</td>
                  </tr>
                  <tr>
                    <td>Sentry</td>
                    <td>Logging</td>
                    <td>US</td>
                  </tr>
                </tbody>
              </table>
              <h2 className='dark:text-slate-200' id='content-delivery-networks'>
                <a href='#content-delivery-networks' aria-hidden='true'>
                  <span className='icon icon-link'></span>
                </a>
                Content Delivery Networks
              </h2>
              <p>
                As explained above, Easy-Peasy.AI may use content delivery
                networks (“CDNs”) to provide the Services, for security
                purposes, and to optimize content delivery. CDNs are commonly
                used systems of distributed services that deliver content based
                on the geographic location of the individual accessing the
                content and the origin of the content provider. Website content
                served to website visitors and domain name information may be
                stored with a CDN to expedite transmission, and information
                transmitted across a CDN may be accessed by that CDN to enable
                its functions. The following describes use of CDNs by
                Easy-Peasy.AI’s Services.
              </p>

              <table>
                <thead>
                  <tr>
                    <th>CDN Provider</th>
                    <th>Services Using CDN</th>
                    <th>Description of CDN Services</th>
                    <th>CDN Location</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>Cloudflare</td>
                    <td>All Easy-Peasy.AI Services</td>
                    <td>
                      Public website content served to website visitors may be
                      stored with Cloudflare, Inc., and transmitted by
                      Cloudflare, Inc., to website visitors, to expedite
                      transmission.
                    </td>
                    <td>Global</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </main>);
};
export default SubProcessors;

    async function __Next_Translate__getStaticProps__1a1052e9172__(ctx) {
      if (typeof global !== 'undefined') {
        global.i18nConfig = __i18nConfig
      }
      
      return {
        
        
        props: {
          
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/sub-processors',
            loaderName: 'getStaticProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || ((l, n) => import('../../locales/' + l + '/' + n).then(m => m.default)),
          }))
        }
      }
    }
    export { __Next_Translate__getStaticProps__1a1052e9172__ as getStaticProps }
  